import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ticketService } from '../api/ticketService';
import {
  MASTER_DATA_KEYS,
  masterDataQueryOptions,
  extractMasterDataArray,
} from '../lib/masterDataQuery';

/**
 * Session-cached ticket priorities from GET /gateway/api/ticket/reference/priorities.
 * @param {{ enabled?: boolean }} [options]
 */
export function usePriorities(options = {}) {
  const { enabled = true } = options;

  const query = useQuery({
    queryKey: MASTER_DATA_KEYS.priorities,
    queryFn: () => ticketService.getTicketPriorities(),
    ...masterDataQueryOptions,
    enabled,
  });

  const data = useMemo(
    () => extractMasterDataArray(query.data),
    [query.data]
  );

  return {
    ...query,
    data,
    response: query.data,
  };
}

export default usePriorities;
